import { ContentBlockType, SuperLatexBlock } from '../../../model';

export const DEFAULT_SUPER_LATEX_PROPS = {
  type: ContentBlockType.SuperLatex,
  latex_nodes: [],
} as const satisfies Partial<SuperLatexBlock>;
